export const walletInitialState = {
    credits: 0,
}

export const initialState = {
    ...walletInitialState,
  };